/**
 * Theme modal popups API
 */
document.addEventListener('DOMContentLoaded', () => {
  // Init modals on page load
  document.querySelectorAll('#modal-popup').forEach((container, i, arr) => {
    theme.modalPopup(container, i, arr);
  });

  // Init modal open triggers
  document.querySelectorAll('#modal-trigger').forEach((trigger, i, arr) => {
    const modalId = trigger.getAttribute('data-modal-id');
    const searchInput = document.querySelector('.search-input');
    trigger.addEventListener('click', (e) => {
      if (!window.Modals[modalId]) return;

      if (e.target.classList.contains('open')) {
        e.target.classList.remove('open');
        window.Modals[modalId].close();
      } else {
        arr.forEach((trigg) => {
          trigg.classList.remove('open');
        });

        e.target.classList.add('open');
        window.Modals[modalId].open();
        if (e.target.classList.contains('open') && e.target.classList.contains('search-button')) {
          searchInput.focus();
        }
      }
    });
  });
});

/**
 * Prepare modal popup
 */
theme.modalPopup = (container, i, arr) => {
  // modal Open
  const modalOpen = () => {
    arr.forEach((modal) => {
      modal.classList.remove('open');
      document.documentElement.style.setProperty('--header-transform', 'translateY(0)');
      document.dispatchEvent(new CustomEvent('modal:close', {detail: modal}));
    });

    container.classList.add('open');
    document.dispatchEvent(new CustomEvent('modal:open', {detail: container}));
  };

  // modal Close
  const modalClose = () => {
    container.classList.remove('open');
    document.dispatchEvent(new CustomEvent('modal:close', {detail: container}));
  };

  const modalId = container.getAttribute('data-modal-id');
  window.Modals = window.Modals || [];
  window.Modals[modalId] = {
    open: modalOpen,
    close: modalClose,
  };

  return {
    modalPopup: this,
  };
};

// Bind modal close
document.addEventListener('click', (e) => {
  const el = e.target;
  const modal = el.closest('#modal-popup');
  if (!modal) return;
  if (
    el.getAttribute('id') === 'modal-popup__content' ||
    (el.closest('#modal-popup__content') && !el.classList.contains('modal-popup__close'))
  )
    return;

  // Close all modals
  const modals = document.querySelectorAll('[data-modal-id]');
  modals.forEach((modalEl) => {
    modalEl.classList.remove('open');
    document.dispatchEvent(new CustomEvent('modal:close', {detail: modalEl}));
  });
});

async function cartDrawerViewed() {
  try {
    // Shopify custom pixel event cart_drawer_viewed
    const customData = await theme.cart.getCart();
    customData.items = customData.items.reduce((accumulator, item) => {
      const existingItem = accumulator.find((existing) => item.id === existing.id && item.final_price === existing.final_price && item.final_price === 0);

      if (existingItem) {
        existingItem.quantity += item.quantity;
      } else {
        accumulator.push(item);
      }

      return accumulator;
    }, []);

    Shopify.analytics.publish('cart_drawer_viewed', customData);
  } catch (error) {
    console.error(error);
  }
}

// Modal open event
document.addEventListener('modal:open', (event) => {
  const {body} = document;
  body.classList.add('modal-open');
  body.classList.add('no-scroll');
  if(event.detail.getAttribute('data-modal-id') === 'cart'){
    cartDrawerViewed();
  }
});

// Modal close event
document.addEventListener('modal:close', () => {
  const {body} = document;
  body.classList.remove('modal-open');
  body.classList.remove('no-scroll');
});

export default theme.modalPopup;
